export default [
  {
    path: '/tradingRecord',
    name: 'tradingRecord',
    component: () => import('@/views/common/tradingRecord'),
    meta: {
      title: 'title.title4'
    }
  },
  {
    path: '/myPosition',
    name: 'myPosition',
    component: () => import('@/views/common/myPosition'),
    meta: {
      title: 'title.title2'
    }
  },
  {
    path: '/planForChange',
    name: 'planForChange',
    component: () => import('@/views/common/planForChange'),
    meta: {
      title: ''
    }
  },
  {
    path: '/homePage',
    name: 'homePage',
    component: () => import('@/views/common/homePage'),
    meta: {
      title: ''
    }
  },
  {
    path: '/planForBirth',
    name: 'planForBirth',
    component: () => import('@/views/common/planForBirth'),
    meta: {
      title: ''
    }
  },
  {
    path: '/planForPerMonth',
    name: 'planForPerMonth',
    component: () => import('@/views/common/planForPerMonth'),
    meta: {
      title: ''
    }
  },
  {
    path: '/planForYear',
    name: 'planForYear',
    component: () => import('@/views/common/planForYear'),
    meta: {
      title: ''
    }
  },
  {
    path: '/IntelligentDepositProducts',
    name: 'IntelligentDepositProducts',
    component: () => import('@/views/common/IntelligentDepositProducts'),
    meta: {
      title: 'title.title1'
    }
  },
  {
    path: '/ProductCategories',
    name: 'ProductCategories',
    component: () => import('@/views/common/ProductCategories'),
    meta: {
      title: 'title.title0'
    }
  },
  {
    path: '/transactionResult',
    name: 'transactionResult',
    component: () => import('@/views/common/transactionResult'),
    meta: {
      title: 'title.title7',
      result: false
    }
  },
  {
    path: '/withdrawResult',
    name: 'withdrawResult',
    component: () => import('@/views/common/withdrawResult'),
    meta: {
      title: 'title.title8',
      result: false
    }
  },
  {
    path: '/accountInformationOfDay',
    name: 'accountInformationOfDay',
    component: () => import('@/views/dayProfit/accountInformationOfDay'),
    meta: {
      title: 'title.title1'
    }
  },
  {
    path: '/depositOfDay',
    name: 'depositOfDay',
    component: () => import('@/views/dayProfit/depositOfDay'),
    meta: {
      title: 'title.title12'
    }
  },
  {
    path: '/depositOfMonth',
    name: 'depositOfMonth',
    component: () => import('@/views/monthHigh/depositOfMonth'),
    meta: {
      title: 'title.title5'
    }
  },
  {
    path: '/accountInformationOfMonth',
    name: 'accountInformationOfMonth',
    component: () => import('@/views/monthHigh/accountInformationOfMonth'),
    meta: {
      title: 'title.title1'
    }
  },
  {
    path: '/depositOfCurrent',
    name: 'depositOfCurrent',
    component: () => import('@/views/currentDeposit/depositOfCurrent'),
    meta: {
      title: 'title.title10'
    }
  },
  {
    path: '/informationEntryOfCurrent',
    name: 'informationEntryOfCurrent',
    component: () => import('@/views/currentDeposit/informationEntryOfCurrent'),
    meta: {
      title: 'title.title1'
    }
  },
  {
    path: '/accountInformationOfCurrent',
    name: 'accountInformationOfCurrent',
    component: () => import('@/views/currentDeposit/accountInformationOfCurrent'),
    meta: {
      title: 'title.title3'
    }
  },
  {
    path: '/withdrawEntryOfCurrent',
    name: 'withdrawEntryOfCurrent',
    component: () => import('@/views/currentDeposit/withdrawEntryOfCurrent'),
    meta: {
      title: 'title.title14'
    }
  },
  {
    path: '/cancelOfCurrent',
    name: 'cancelOfCurrent',
    component: () => import('@/views/currentDeposit/cancelOfCurrent'),
    meta: {
      title: 'title.title15'
    }
  },
  {
    path: '/informationConfirmOfCurrent',
    name: 'informationConfirmOfCurrent',
    component: () => import('@/views/currentDeposit/informationConfirmOfCurrent'),
    meta: {
      title: 'title.title9'
    }
  },
  {
    path: '/accountInformationOfRegular',
    name: 'accountInformationOfRegular',
    component: () => import('@/views/regularDeposit/accountInformationOfRegular'),
    meta: {
      title: 'title.title3'
    }
  },
  {
    path: '/depositOfRegular',
    name: 'depositOfRegular',
    component: () => import('@/views/regularDeposit/depositOfRegular'),
    meta: {
      title: 'title.title11'
    }
  },
  {
    path: '/accountInformationOfPerMonth',
    name: 'accountInformationOfPerMonth',
    component: () => import('@/views/PerMonthDeposit/accountInformationOfPerMonth'),
    meta: {
      title: 'title.title3'
    }
  },
  {
    path: '/depositOfPerMonth',
    name: 'depositOfPerMonth',
    component: () => import('@/views/PerMonthDeposit/depositOfPerMonth'),
    meta: {
      title: 'title.title13'
    }
  },
  {
    path: '/informationConfirmOfPerMonth',
    name: 'informationConfirmOfPerMonth',
    component: () => import('@/views/PerMonthDeposit/informationConfirmOfPerMonth'),
    meta: {
      title: 'title.title9'
    }
  },
  {
    path: '/informationEntryOfPerMonth',
    name: 'informationEntryOfPerMonth',
    component: () => import('@/views/PerMonthDeposit/informationEntryOfPerMonth'),
    meta: {
      title: 'title.title6'
    }
  },
  {
    path: '/monthInformationEntry',
    name: 'monthInformationEntry',
    component: () => import('@/views/monthHigh/monthInformationEntry'),
    meta: {
      title: 'title.title6'
    }
  },
  {
    path: '/monthInformationComfirm',
    name: 'monthInformationComfirm',
    component: () => import('@/views/monthHigh/monthInformationComfirm'),
    meta: {
      title: 'title.title9'
    }
  }
]
